import {doDelete, doGet, doPost} from "./http.service";
import {User} from "../types/User";

export interface FacebookConnectUrl {
    url: string;
}

export interface FacebookPage {
    id: string;
    name: string;
    canPost: boolean;
    connected: boolean;
}

export function loadFacebookConnectUrl() {
    return doGet<FacebookConnectUrl>("/facebook/connect-url");
}

export function loadFacebookPages() {
    return doGet<FacebookPage[]>("/facebook/pages");
}

export function selectFacebookPage(pageId: string) {
    return doPost<User>("/facebook/pages/select", {pageId});
}

export function disconnectFacebook() {
    return doDelete<User>("/facebook/disconnect");
}
